import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountReceivable } from 'src/app/models/account-receivable.model';
import { BankService } from 'src/app/services/bank.service';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { CashClosureService } from 'src/app/services/cash-closure.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { CashClosureAccountRequest, CashClosureRequest } from 'src/app/models/cash-closure.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { concatMap } from 'rxjs/operators';
import { AccountResponse, ErpBankResponse } from 'src/app/models/account.model';
import { CardTypeResponse } from 'src/app/models/card.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ActivatedRoute } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-accounts-receivable',
  templateUrl: './accounts-receivable.component.html',
  styleUrls: ['./accounts-receivable.component.scss', '../cash-closure/cash-closure.component.scss']
})
export class AccountsReceivableComponent implements OnInit {
  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  accounts: CashClosureAccountRequest[] = [];
  bankAccounts: AccountResponse[] = []
  timeout = null;
  showDataPayment: { [key: string]: boolean } = {};
  banks: ErpBankResponse[] = [];
  bank = null;
  typeCards: CardTypeResponse[] = [];
  user = null;
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  cashiers = [];
  filterCashiers = [];
  input = new InputAutocompleteModel("", false, true, "", "", "", "", null, []);
  objectCashiers: { [key: number]: any } = {};

  constructor(
    private toastService: ToastrService,
    private bankService: BankService,
    private invoiceService: InvoiceSaleService,
    private cashService: CashClosureService,
    private authService: AuthenticationService
  ) {
    this.user = this.authService.getUserPosition();
  }

  getPreviousList() {
    var previousList = sessionStorage.getItem('account-receivable');
    if (previousList) {
      var previous: CashClosureAccountRequest[] = JSON.parse(previousList);
      previous.forEach((p) => {
        var temp = new CashClosureAccountRequest;
        temp.typePayment = p.typePayment;
        temp.accountIdTransfer = p.accountIdTransfer;
        temp.amount = p.amount;
        temp.amountAdvanceTransfer = p.amountAdvanceTransfer;
        temp.authorizationCard = p.authorizationCard;
        temp.bankCheck = p.bankCheck;
        temp.clientId = p.clientId;
        temp.client = p.client;
        temp.date = p.date;
        temp.dateCheck = p.dateCheck;
        temp.image = p.image;
        temp.numberAccountCheck = p.numberAccountCheck;
        temp.numberCheck = p.numberCheck;
        temp.numberTransfer = p.numberTransfer;
        temp.reference = p.reference;
        temp.referenceCard = p.referenceCard;
        temp.typeCard = p.typeCard;
        temp.typePayment = p.typePayment;
        if (p.numberAccountCheck) {
          var cashier = this.cashiers.find((r) => r.id == p.numberAccountCheck);
          temp.cash = new InputAutocompleteModel(cashier.name, true, true, "", "fa-circle-check", "", "", null, this.cashiers);
        } else {
          temp.cash = new InputAutocompleteModel("", false, true, "", "fa-list", "", "", null, this.cashiers);
        }
        this.accounts.push(temp);
      });
    }
  }

  ngOnInit(): void {
    this.invoiceService.getClients().pipe(
      concatMap((response: ResponseObject) => {
        this.clients = response.data;
        this.client.filterElements = response.data;
        this.client.class = "fa-list";
        return this.bankService.getBanks();
      }),
      concatMap((response: ResponseObject) => {
        this.banks = response.data;
        this.bank = this.banks[0].id;
        return this.invoiceService.getCash();
      }),
      concatMap((response: ResponseObject) => {
        this.cashiers = Object(response)['data'];
        this.filterCashList();
        return this.invoiceService.getCardTypes();
      }),
      concatMap((response: ResponseObject) => {
        this.typeCards = response.data;
        return this.invoiceService.getBankActiveAccounts();
      })
    ).subscribe(
      (response: ResponseObject) => {
        this.bankAccounts = response.data;
        this.getPreviousList();
      },
      (error) => {
        console.log("Error al comunicarse con el servidor");
      }
    );
  }

  filterCashList() {
    var currentUserPosition = this.authService.getUserPosition();
    if (currentUserPosition) {
      const unique = new Set<number>();
      currentUserPosition.forEach((elemento) => {
        unique.add(elemento.cash);
      });
      const filter = Array.from(unique);
      this.cashiers = this.cashiers.filter(cash => filter.includes(cash.id));
    }
  }

  writeCashier(account) {
    let temp: any = this.cashiers.filter((cashier) =>
      (cashier.id + " - " + cashier.name).toLowerCase().includes(account.cash.value.toLowerCase())
    );
    if (temp.length == 0) {
      account.cash.class = "fa-ban";
    } else {
      account.cash.class = "fa-list";
    }
    account.cash.data = null;
    account.cash.filterElements = temp;
    account.numberAccountCheck = undefined;
    this.updateClientList();
  }

  selectCashier(cashier, account) {
    account.cash.data = cashier;
    account.cash.value = cashier.name;
    account.cash.class = "fa-circle-check";
    account.cash.verified = true;
    account.numberAccountCheck = cashier.id;
    this.updateClientList();
  }

  selectImage(index: number) {
    $('#file' + index).click();
  }

  changeFile(event: any, index: number, account: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        account.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  updateClientList() {
    sessionStorage.setItem('account-receivable', JSON.stringify(this.accounts));
  }

  changeTypePayment(index: number) {
    var temp = Object.assign({}, this.accounts[index]);
    this.accounts[index] = new CashClosureAccountRequest();
    this.accounts[index].client = temp.client;
    this.accounts[index].typePayment = temp.typePayment;
    this.accounts[index].clientId = temp.clientId;
    this.accounts[index].amount = temp.amount;
    this.accounts[index].reference = temp.reference;
    this.accounts[index].date = temp.date;
    this.accounts[index].cash = new InputAutocompleteModel("", false, true, "", "fa-list", "", "", null, this.cashiers);
    this.updateClientList();
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";
    this.timeout = setTimeout(() => {
      this.client.class = "loading";
      this.invoiceService.getClientsByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data;
          if (this.client.filterElements.length == 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        }, error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener los datos del cliente " + this.client.value);
        }
      })
    }, 500);
  }

  selectClient(client: any, status) {
    this.client.value = "";
    this.client.class = "";
    this.client.required = false;
    this.addClientToAccountList(client);
    this.filterClients = this.clients;
    $('body').click();
  }

  deleteClientOfList(index: number) {
    this.accounts.splice(index, 1);
    sessionStorage.setItem('account-receivable', JSON.stringify(this.accounts));
  }

  addClientToAccountList(client: any) {
    var findOut = this.accounts.find((c) => {
      return c.client.nit == client.nit
    });
    if (findOut) {
      this.toastService.info("El cliente ya se encuentra agregado a la lista");
    } else {
      var newAccount = new CashClosureAccountRequest();
      newAccount.client = client;
      newAccount.clientId = client.id;
      newAccount.typePayment = 0;
      newAccount.cash = new InputAutocompleteModel("", false, true, "", "", "", "", null, this.cashiers);
      this.showDataPayment[newAccount.clientId] = true;
      this.accounts.push(newAccount);
      sessionStorage.setItem('account-receivable', JSON.stringify(this.accounts));
    }
  }

  saveAccountReceivable() {
    if (this.buttonSave.loading) {
      return;
    }
    var requestAccounts = [];
    for (let i = 0; i < this.accounts.length; i++) {
      const account = this.accounts[i];
      var newAccountRequest = new CashClosureAccountRequest();
      newAccountRequest.clientId = account.clientId;
      if (account.date && account.amount && account.reference) {
        newAccountRequest.date = account.date;
        newAccountRequest.amount = account.amount;
        newAccountRequest.reference = account.reference;
      } else {
        this.toastService.error("Completa todos los campos del cliente " + account.client.name);
        return;
      }
      newAccountRequest.logo = account.logo;
      newAccountRequest.typePayment = account.typePayment;
      if (account.typePayment == 0) {
        if (account.numberAccountCheck) {
          newAccountRequest.numberAccountCheck = account.numberAccountCheck;
        } else {
          account['isIncomplete'] = true;
          this.incompleteDataClient(account.client.name);
          return;
        }
      }
      else if (account.typePayment == 1) {
        if (account.bankCheck && account.dateCheck && account.numberCheck && account.numberAccountCheck) {
          newAccountRequest.bankCheck = account.bankCheck;
          newAccountRequest.dateCheck = account.dateCheck;
          newAccountRequest.numberCheck = account.numberCheck;
          newAccountRequest.numberAccountCheck = account.numberAccountCheck;
        } else {
          account['isIncomplete'] = true;
          this.incompleteDataClient(account.client.name);
          return;
        }
      } else if (account.typePayment == 2) {
        if (account.typeCard && account.referenceCard && account.authorizationCard) {
          newAccountRequest.typeCard = account.typeCard;
          newAccountRequest.referenceCard = account.referenceCard;
          newAccountRequest.authorizationCard = account.authorizationCard;
        } else {
          account['isIncomplete'] = true;
          this.incompleteDataClient(account.client.name);
          return;
        }
      } else if (account.typePayment == 3) {
        if (account.numberTransfer && account.accountIdTransfer) {
          newAccountRequest.numberTransfer = account.numberTransfer;
          newAccountRequest.accountIdTransfer = account.accountIdTransfer;
          newAccountRequest.amountAdvanceTransfer = account.amountAdvanceTransfer ? account.amountAdvanceTransfer : 0;
        } else {
          account['isIncomplete'] = true;
          this.incompleteDataClient(account.client.name);
          return;
        }
      }
      requestAccounts.push(newAccountRequest);
    }
    this.buttonSave.loading = true;
    this.cashService.createAccountReceivable(requestAccounts).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success(requestAccounts.length > 1 ? 'Cuentas por cobrar saldadas!' : 'Cuenta saldada!');
        this.reset();
        this.buttonSave.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  incompleteDataClient(clientName: string) {
    this.toastService.error("Completa los datos del tipo de cobro de " + clientName);
    this.buttonSave.loading = false;
  }

  reset() {
    this.accounts = [];
    this.updateClientList();
  }

}
